module.exports = __webpack_public_path__ + "img/chicken.a0767904.svg";